const translations = {
  zh: {
    // Navigation
    nav: {
      home: 'Benjamin',
      about: '关于',
      resume: '简历',
      projects: '项目',
      stats: '统计',
      contact: '联系',
    },
    // Page titles and descriptions
    pages: {
      home: {
        title: '首页',
        description: 'Benjamin的个人网站。Web3全栈开发者，DAOSquare工程师，YC校友。',
        heading: '关于本站',
        subheading: '一个美观、响应式、静态生成的React应用，使用现代JavaScript编写。',
        welcome: '欢迎访问我的网站。您可以',
        readMore: '了解更多关于我',
        checkResume: '查看我的简历',
        viewProjects: '浏览项目',
        viewStats: '查看网站统计',
        contactMe: '联系我',
        or: '或',
        comma: '，',
        sourceAvailable: '源代码可在',
        here: '这里',
        available: '获取',
      },
      about: {
        title: '关于我',
        description: '了解更多关于Benjamin的信息',
        heading: '关于我',
        wordCount: '（约',
        words: '字）',
      },
      resume: {
        title: '个人简历',
        description: 'Benjamin的工作经历和技能',
        heading: '简历',
        sections: {
          education: '教育背景',
          experience: '工作经历',
          skills: '技能',
          references: '推荐',
        },
        skills: {
          title: '技能',
          description: '注意：我认为这些部分很傻，但似乎每个人都有一个。这是我技能的*基本*诚实概述。',
        },
      },
      projects: {
        title: '项目展示',
        description: 'Benjamin参与和创建的项目',
        heading: '项目',
      },
      stats: {
        title: '数据统计',
        description: '关于本网站的一些有趣统计数据',
        heading: '网站统计',
        personalStatsTitle: '关于我的一些统计',
      },
      contact: {
        title: '联系方式',
        description: '通过邮箱 luhuimao@gmail.com 联系Benjamin',
        heading: '联系',
        intro: '欢迎与我联系。您可以通过以下邮箱联系我：',
      },
      notFound: {
        title: '未找到',
        description: '页面未找到',
        heading: '页面未找到',
        message: '抱歉，您访问的页面不存在。',
        goHome: '返回首页',
      },
    },
    // Language switcher
    language: {
      current: '中文',
      switch: '切换语言',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Benjamin Loo',
      about: 'About',
      resume: 'Resume',
      projects: 'Projects',
      stats: 'Stats',
      contact: 'Contact',
    },
    // Page titles and descriptions
    pages: {
      home: {
        title: 'Home',
        description: "Benjamin Loo's personal website. Web3 full stack developer, DAOSquare engineer, and YC Alumni.",
        heading: 'About this site',
        subheading: 'A beautiful, responsive, statically-generated, React application written with modern Javascript.',
        welcome: 'Welcome to my website. Please feel free to read more',
        readMore: 'about me',
        checkResume: 'resume',
        viewProjects: 'projects',
        viewStats: 'site statistics',
        contactMe: 'contact',
        or: 'or',
        comma: ',',
        sourceAvailable: 'Source available',
        here: 'here',
        available: '',
      },
      about: {
        title: 'About Me',
        description: 'Learn more about Benjamin Loo',
        heading: 'About Me',
        wordCount: '(in about',
        words: 'words)',
      },
      resume: {
        title: 'Resume',
        description: "Benjamin Loo's work experience and skills",
        heading: 'Resume',
        sections: {
          education: 'Education',
          experience: 'Experience',
          skills: 'Skills',
          references: 'References',
        },
        skills: {
          title: 'Skills',
          description: 'Note: I think these sections are silly, but everyone seems to have one. Here is a *mostly* honest overview of my skills.',
        },
      },
      projects: {
        title: 'Projects',
        description: 'Projects Benjamin Loo has worked on',
        heading: 'Projects',
      },
      stats: {
        title: 'Statistics',
        description: 'Some interesting statistics about this website',
        heading: 'Site Statistics',
        personalStatsTitle: 'Some stats about me',
      },
      contact: {
        title: 'Contact',
        description: 'Contact Benjamin Loo via email @ luhuimao@gmail.com',
        heading: 'Contact',
        intro: 'Feel free to get in touch. You can email me at:',
      },
      notFound: {
        title: 'Not Found',
        description: 'Page not found',
        heading: 'Page Not Found',
        message: "Sorry, the page you are looking for doesn't exist.",
        goHome: 'Go Home',
      },
    },
    // Language switcher
    language: {
      current: 'English',
      switch: 'Switch Language',
    },
  },
};

export default translations;
